import type { ShopBankAccountPart, ShopUpdateRequest } from "@/api/stores/type";

/** 银行账户相关字段，需写入 bankAccount 子对象 */
const BANK_ACCOUNT_FIELDS = new Set<keyof ShopBankAccountPart>([
  "accountName",
  "accountNo",
  "bankName",
  "invoiceTitle",
  "taxId",
]);

/**
 * 将行内编辑字段名与值转为 updateShop 请求体
 * @param field 字段名（与 ShopUpdateRequest 顶层或 bankAccount 子字段对应）
 * @param value 编辑后的字符串值
 */
export const buildShopUpdatePayload = (field: string, value: string): ShopUpdateRequest => {
  // 银行账户字段写入嵌套对象
  if (BANK_ACCOUNT_FIELDS.has(field as keyof ShopBankAccountPart)) {
    return {
      bankAccount: {
        [field]: value,
      } as ShopBankAccountPart,
    };
  }
  // 区域标签：支持顿号、中英文逗号分隔
  if (field === "regionTags") {
    const tags = value
      .split(/[、,，]/)
      .map((item) => item.trim())
      .filter(Boolean);
    return { regionTags: tags };
  }
  // 品牌：单 ID
  if (field === "brandTagId" || field === "brandTags") {
    const first = value
      .split(/[、,，]/)
      .map((item) => item.trim())
      .filter(Boolean)[0];
    return { brandTagId: first };
  }
  // 门店面积：去掉单位后解析数字
  if (field === "areaSqm") {
    const num = parseFloat(value.replace(/[㎡m²\s]/g, ""));
    return { areaSqm: Number.isNaN(num) ? undefined : num };
  }
  // 证照 URL：后端为 string[]
  if (
    field === "shopLogo" ||
    field === "doorPhotoUrl" ||
    field === "premisePhotoUrl" ||
    field === "floorPlanUrl"
  ) {
    return { [field]: value ? [value] : [] };
  }
  return { [field]: value };
};
